<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Profil</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="profil">

    <div class="allapot" *ngIf="betolt"><ion-spinner name="crescent"></ion-spinner> A profil betöltése…</div>

    <ion-card *ngIf="!betolt && hiba" class="hiba-kartya">
      <ion-card-content>
        <p>{{ hiba }}</p>
        <ion-button fill="outline" size="small" (click)="frissit()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon> Újra
        </ion-button>
      </ion-card-content>
    </ion-card>

    <ng-container *ngIf="!betolt && p">

      <!-- ── Fejrész: nagy kép, név, szerepek ─────────────────────────────── -->
      <ion-card class="fej">
        <ion-card-content>
          <div class="fej-sor">
            <img class="nagy-kep" [src]="sajatKep" alt="Profilkép" (error)="kepHiba($event)">
            <div class="fej-szoveg">
              <h1>{{ nev }}</h1>
              <div class="cimkek">
                <span class="cimke" *ngFor="let s of szerepek">{{ szerepNev(s) }}</span>
              </div>
              <div class="halvany" *ngIf="p.fiok?.felhasznalonev">{{ p.fiok.felhasznalonev }}</div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>

      <!-- ── Fiók ────────────────────────────────────────────────────────── -->
      <ion-card>
        <ion-card-header><ion-card-title>Fiók</ion-card-title></ion-card-header>
        <ion-card-content>
          <dl class="adatok">
            <div><dt>Felhasználónév</dt><dd>{{ p.fiok?.felhasznalonev || '–' }}</dd></div>
            <div><dt>E-mail</dt><dd class="tor">{{ email || '–' }}</dd></div>
            <div *ngIf="telefon"><dt>Telefon</dt><dd>{{ telefon }}</dd></div>
            <div><dt>Belépés módja</dt><dd>{{ p.fiok?.belepes?.leiras || '–' }}</dd></div>
            <div *ngIf="belepesiSzerep"><dt>Belépve mint</dt><dd>{{ belepesiSzerep }}</dd></div>
            <div *ngIf="aktivIntezmeny"><dt>Most használt intézmény</dt><dd>{{ aktivIntezmeny }}<span class="halvany" *ngIf="aktivModul"> · {{ aktivModul }}</span></dd></div>
            <div *ngIf="tema"><dt>Megjelenés</dt><dd>{{ tema }} téma</dd></div>
          </dl>
        </ion-card-content>
      </ion-card>

      <!-- ── Munkatárs ───────────────────────────────────────────────────── -->
      <ion-card *ngIf="dolgozo">
        <ion-card-header><ion-card-title>Munkatársi adatok</ion-card-title></ion-card-header>
        <ion-card-content>
          <dl class="adatok">
            <div><dt>Név</dt><dd>{{ dolgozo.nev || '–' }}</dd></div>
            <div><dt>Azonosító</dt><dd class="tor">{{ dolgozo.adid }}</dd></div>
            <div *ngIf="dolgozo.oktazon"><dt>Oktatási azonosító</dt><dd>{{ dolgozo.oktazon }}</dd></div>
            <div *ngIf="dolgozo.vegzettseg"><dt>Végzettség</dt><dd>{{ dolgozo.vegzettseg }}</dd></div>
          </dl>

          <h3 class="alcim" *ngIf="dolgozo.intezmenyek?.length">Intézmények és jogkörök</h3>
          <div class="hely" *ngFor="let h of dolgozo.intezmenyek" [class.megszunt]="h.megszunt">
            <div class="hely-fej">
              <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
              <b>{{ h.nev }}</b>
              <span class="cimke kicsi" *ngIf="h.foallas">főállás</span>
              <span class="cimke kicsi" *ngIf="h.vezeto">vezető</span>
              <span class="cimke kicsi szurke" *ngIf="h.megszunt">megszűnt</span>
            </div>
            <dl class="adatok">
              <div *ngIf="h.munkakor"><dt>Munkakör</dt><dd>{{ h.munkakor }}</dd></div>
              <div *ngIf="h.jogviszony"><dt>Jogviszony</dt><dd>{{ h.jogviszony }}</dd></div>
              <div *ngIf="h.jogviszony_kezd || h.jogviszony_vege"><dt>Időtartam</dt>
                <dd>{{ h.jogviszony_kezd ? datum(h.jogviszony_kezd) : '…' }} – {{ h.jogviszony_vege ? datum(h.jogviszony_vege) : '' }}</dd></div>
              <div *ngIf="h.heti_oraszam"><dt>Heti óraszám</dt><dd>{{ h.heti_oraszam }}</dd></div>
              <div *ngIf="h.email"><dt>Munkahelyi e-mail</dt><dd class="tor">{{ h.email }}</dd></div>
              <div *ngIf="h.telefon"><dt>Munkahelyi telefon</dt><dd>{{ h.telefon }}</dd></div>
              <div *ngFor="let c of jogkorCsoportok(h.jogkorok)">
                <dt>{{ c.modul ? 'Jogkör – ' + c.modul : 'Jogkör' }}</dt><dd>{{ c.nevek }}</dd>
              </div>
            </dl>
          </div>

          <ng-container *ngTemplateOutlet="szemelyes; context: { $implicit: dolgozo }"></ng-container>
        </ion-card-content>
      </ion-card>

      <!-- ── Tanuló (saját maga) ─────────────────────────────────────────── -->
      <ion-card *ngIf="tanulo">
        <ion-card-header><ion-card-title>Tanulói adatok</ion-card-title></ion-card-header>
        <ion-card-content>
          <ng-container *ngTemplateOutlet="tanuloAdat; context: { $implicit: tanulo }"></ng-container>
          <ng-container *ngTemplateOutlet="szemelyes; context: { $implicit: tanulo }"></ng-container>
        </ion-card-content>
      </ion-card>

      <!-- ── Gondviselő (saját maga) ─────────────────────────────────────── -->
      <ion-card *ngIf="gondviselo">
        <ion-card-header><ion-card-title>Gondviselői adatok</ion-card-title></ion-card-header>
        <ion-card-content>
          <dl class="adatok">
            <div><dt>Név</dt><dd>{{ gondviselo.nev || '–' }}</dd></div>
            <div *ngIf="gondviselo.email"><dt>E-mail</dt><dd class="tor">{{ gondviselo.email }}</dd></div>
            <div *ngIf="gondviselo.telefon"><dt>Telefon</dt><dd>{{ gondviselo.telefon }}</dd></div>
            <div *ngIf="gondviselo.intezmenyek?.length"><dt>Iskola</dt>
              <dd><ng-container *ngFor="let i of gondviselo.intezmenyek; let utolso = last">{{ i.nev }}<ng-container *ngIf="!utolso">, </ng-container></ng-container></dd></div>
          </dl>
          <ng-container *ngTemplateOutlet="szemelyes; context: { $implicit: gondviselo }"></ng-container>
        </ion-card-content>
      </ion-card>

      <!-- ── Gyermekek ───────────────────────────────────────────────────── -->
      <ng-container *ngIf="gyermekek.length">
        <h2 class="szakasz">{{ gyermekek.length > 1 ? 'Gyermekeim' : 'Gyermekem' }}</h2>
        <ion-card *ngFor="let g of gyermekek" class="gyermek">
          <ion-card-content>
            <div class="gyermek-fej">
              <span class="kozepes-kep">
                <img *ngIf="kepek[g.oktazon]; else gyMono" [src]="kepek[g.oktazon]" alt="">
                <ng-template #gyMono>{{ monogram(g.nev) }}</ng-template>
              </span>
              <div>
                <h3>{{ g.nev }}</h3>
                <div class="halvany">
                  <ng-container *ngIf="g.osztaly">{{ g.osztaly }} osztály</ng-container>
                  <ng-container *ngIf="g.osztaly && g.intezmeny_nev"> · </ng-container>{{ g.intezmeny_nev }}
                </div>
                <span class="cimke kicsi" *ngIf="g.rokonsag">{{ g.rokonsag }}</span>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="tanuloAdat; context: { $implicit: g }"></ng-container>
            <ng-container *ngTemplateOutlet="szemelyes; context: { $implicit: g }"></ng-container>
          </ion-card-content>
        </ion-card>
      </ng-container>

      <!-- ── Hol módosítható ─────────────────────────────────────────────── -->
      <ion-card class="megjegyzes">
        <ion-card-header><ion-card-title>Adatok módosítása</ion-card-title></ion-card-header>
        <ion-card-content>
          <ul>
            <li>Az adatokat ezen az oldalon nem lehet módosítani. Ha valami hibás vagy hiányzik,
              <ng-container *ngIf="dolgozo">a munkatársi adatokat az iskola titkárságán (munkaügy) kérheted javítani.</ng-container>
              <ng-container *ngIf="!dolgozo">jelezd az iskolának: az osztályfőnöknél vagy a titkárságon.</ng-container>
            </li>
            <li *ngIf="gyermekek.length">A gyermeked adatainak javítását az osztályfőnöknél vagy az iskola titkárságán kérheted.</li>
            <li *ngIf="microsoftos">A jelszavadat a Microsoft-fiókodban módosíthatod; ha nem sikerül, az iskola rendszergazdája segít.</li>
            <li *ngIf="!microsoftos">Elfelejtett jelszó esetén a belépési oldal jelszó-visszaállító hivatkozásával kérhetsz újat. A jelszó vagy a belépési e-mail cím cseréjében az iskola rendszergazdája segít.</li>
            <li>A megjelenést (témát) a <b>Beállítások</b> menüpontban választhatod.</li>
          </ul>
        </ion-card-content>
      </ion-card>
    </ng-container>
  </div>

  <!-- Tanulói alapadatok – a diáknak magáról és a szülőnek a gyermekéről ugyanez. -->
  <ng-template #tanuloAdat let-t>
    <dl class="adatok">
      <div><dt>Név</dt><dd>{{ t.nev || '–' }}</dd></div>
      <div><dt>Oktatási azonosító</dt><dd>{{ t.oktazon }}</dd></div>
      <div *ngIf="t.intezmeny_nev"><dt>Iskola</dt><dd>{{ t.intezmeny_nev }}</dd></div>
      <div><dt>Osztály</dt><dd>{{ t.osztaly || (t.volt_tanulo ? 'a jogviszony megszűnt' : '–') }}<span class="halvany" *ngIf="t.evfolyam && t.osztaly"> · {{ t.evfolyam }}. évfolyam</span></dd></div>
      <div *ngIf="t.osztalyfonok"><dt>Osztályfőnök</dt><dd>{{ t.osztalyfonok }}</dd></div>
      <div *ngIf="t.jogviszony_kezdete"><dt>Jogviszony kezdete</dt><dd>{{ datum(t.jogviszony_kezdete) }}</dd></div>
      <div *ngIf="t.email"><dt>E-mail</dt><dd class="tor">{{ t.email }}</dd></div>
      <div *ngIf="t.telefon"><dt>Telefon</dt><dd>{{ t.telefon }}</dd></div>
    </dl>
  </ng-template>

  <!-- Személyes adatok: alapból rejtve (kivetítő, közös gép) – a gomb csak megmutatja. -->
  <ng-template #szemelyes let-x>
    <ng-container *ngIf="vanSzemelyes(x)">
      <button type="button" class="mutat" (click)="szemelyesLathato = !szemelyesLathato" [attr.aria-expanded]="szemelyesLathato">
        <ion-icon [name]="szemelyesLathato ? 'eye-off-outline' : 'eye-outline'" aria-hidden="true"></ion-icon>
        {{ szemelyesLathato ? 'Személyes adatok elrejtése' : 'Személyes adatok megjelenítése' }}
      </button>
      <dl class="adatok" *ngIf="szemelyesLathato">
        <div *ngIf="x.szuletesi_nev"><dt>Születési név</dt><dd>{{ x.szuletesi_nev }}</dd></div>
        <div *ngIf="x.szul_hely || x.szul_datum"><dt>Születési hely, idő</dt><dd>{{ szuletes(x) }}</dd></div>
        <div *ngIf="x.anyja_neve"><dt>Anyja neve</dt><dd>{{ x.anyja_neve }}</dd></div>
        <div *ngIf="x.allando_lakcim"><dt>Lakcím</dt><dd>{{ x.allando_lakcim }}</dd></div>
        <div *ngIf="x.tartozkodasi_hely"><dt>Tartózkodási hely</dt><dd>{{ x.tartozkodasi_hely }}</dd></div>
      </dl>
    </ng-container>
  </ng-template>
</ion-content>
